import { FC } from 'react';

import { useSession } from '#hooks/session/useSession';
import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';

interface AgentsProps extends SectionProps {}

export const Agents: FC<AgentsProps> = ({ onClickItem, isMobile, depth }) => {
  const { t } = useI18n();
  const { isAgent, userHelper } = useSession();

  // Only agency admins can see the Agents section, even if they have the agent role
  if (isAgent && !userHelper.isAgencyAdmin()) {
    return null;
  }

  return (
    <Can hasRoles={['buildingManager', 'admin', 'agent']}>
      <NavigationLink
        to={Private.AGENTS.route}
        onClick={onClickItem}
        icon="agent"
        title={t('general.agents')}
        isMobile={isMobile}
        depth={depth}
      />
    </Can>
  );
};
